// extracted by mini-css-extract-plugin
export default {"mainIcon":"XShareLink_mainIcon__hHkH2"};